import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';
import { P } from 'stile-shared/src/components/2020/common/Primitives';

import { PageLayout } from 'templates/2020/PageLayout';
import { SEO } from 'templates/2020/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Victorian Curriculum 2.0"
      description="2026 teacher planning resource"
      slug={props.location.pathname}
    />
  );
}

function VicCurriculumPage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="Victorian Curriculum 2.0"
        subtitle="2026 teacher planning resource"
        id="VIC_CURRICULUM_2026"
        redirectUrl="https://stileapp.com/go/vic2.0"
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/resources/Stile_VIC_2.0_Implementation_2025_print.png"
            alt=""
          />
        }
      >
        <P>
          Stile is a complete, coherent curriculum for science classrooms in Victoria. This document
          outlines the changes to the Victorian Curriculum and how Stile is preparing to align with
          them so you&apos;ll be ready before the anticipated 2026 implementation.{' '}
        </P>
        <P>
          Use our Scope and Sequence as a world-class starting point for designing your
          school&apos;s science program. Alongside our helpful teaching plans and lab guides, it
          offers all the support that graduate teachers need, while the ability to customise gives
          experienced teachers flexibility and freedom.
        </P>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default VicCurriculumPage;
